import { render, staticRenderFns } from "./InitiateProcess.vue?vue&type=template&id=38da16f8"
import script from "./InitiateProcess.vue?vue&type=script&lang=js"
export * from "./InitiateProcess.vue?vue&type=script&lang=js"
import style0 from "./InitiateProcess.vue?vue&type=style&index=0&id=38da16f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports